module.exports = __webpack_public_path__ + "static/empowered-community-2d4f04a8260245a136463c0503a9d3b0.jpg";